import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentTour: null,
    currentPano: null,
    currentCategories: null,
  },
  mutations: {},
  actions: {},
  modules: {},
});
